import { render, staticRenderFns } from "./RewardGridDetailConfig.vue?vue&type=template&id=08691aee&scoped=true&"
import script from "./RewardGridDetailConfig.vue?vue&type=script&lang=js&"
export * from "./RewardGridDetailConfig.vue?vue&type=script&lang=js&"
import style0 from "./RewardGridDetailConfig.vue?vue&type=style&index=0&id=08691aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08691aee",
  null
  
)

export default component.exports